var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('AppNav'),_c('NotificationContainer'),_c('v-main',[_c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[_c('router-view')],1)],1),_c('AppFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }